import React, { useState } from 'react';
import styles from './order.module.scss';
import OrderStatus from './orderStatus';
import OrderTable from './orderTable';
import { KoButton,KoForm, KoLoader, KoModal, KoTabs } from 'packages';

import ProductCurd from '../products/productList/curd';


export default function Order() {
  const [loading] = useState(false);
  const [addProduct, setModalAddProduct] = useState(false);
  const [form] = KoForm.useForm();
  return(
    <div className={`${styles.wrapper} profileSection`}>

      <OrderStatus />
      <KoTabs
        options={[
          {
            label: 'All Status', key: 'all', children: <OrderTable/>
          },
          {
            label: 'Placed', key: 'placed', children: <OrderTable/>
          },
          {
            label: 'Processing', key: 'processing', children: <OrderTable/>
          },
          {
            label: 'Shipping', key: 'shipping', children: <OrderTable/>
          },
          {
            label: 'Success', key: 'success', children: <OrderTable/>
          }
        ]} />

      <KoModal
        title={`Add Product`}
        centered
        afterClose={() => {
          form.resetFields();
        }}
        open={addProduct}
        handleOk={() => {
          setModalAddProduct(false);
        }}
        onClose={() => {
          setModalAddProduct(false);
          form.resetFields();
        }}
        width={"65vw"}
        maskClosable={false}
        footer={[
          <KoButton
            key="cancel"
            label="Cancel"
            onClick={() => {
              setModalAddProduct(false);
              form.resetFields();
            }}
          />,
          <KoButton
            key="create"
            loading={loading}
            type="primary"
            label={`Create`}
            onClick={() => form.submit()}
          />
        ]}
      >
        {loading && <KoLoader circle={false} />}
        <ProductCurd />
      </KoModal>
    </div>
  );
}
